import {
  ADMINISTRATION_CREATE,
  ADMINISTRATION_DELETE,
  ADMINISTRATION_EDIT,
  ADMINISTRATION_VIEW,
  BUSINESS_PLAN_DOWNLOAD_TEMPLATE,
  BUSINESS_PLAN_UPLOAD,
  BUSINESS_PLAN_AND_LOGS_VIEW,
  BUSINESS_PLAN_ONLY_VIEW,
  DASHBOARD_VIEW,
  FORECAST_VIEW,
  MAP_VIEW,
  OPERATION_JOURNAL_VIEW,
  OPERATION_JOURNAL_EDIT,
  OPERATION_JOURNAL_CREATE,
  OPERATION_JOURNAL_COMMENT_CREATE,
  OPERATION_JOURNAL_VIEW_CURRENT_PLANT,
  OPERATION_JOURNAL_SHIFT_TRANSFER_VIEW,
  OPERATION_JOURNAL_SHIFT_ACCEPTANCE_VIEW,
  POWER_BI_VIEW,
  RESTRICTIONS_JOURNAL_VIEW,
  RESTRICTIONS_JOURNAL_EDIT,
  RESTRICTIONS_JOURNAL_CREATE,
  RESTRICTIONS_JOURNAL_DELETE,
  RESTRICTIONS_JOURNAL_CALCULATION,
  RESTRICTIONS_JOURNAL_VIEW_CURRENT_PLANT,
  UNBALANCE_VIEW,
  OPERATION_JOURNAL_SHIFTS_HISTORY_VIEW,
} from 'constants/permissions'

import roles from 'constants/roles'
import {getFeaturePermissions, FlagPages} from 'config/featureFlags'

const roleTypes = {
  APP_CONTENT: 'app',
}

const rules = {
  [roles.ADMIN]: {
    static: [
      DASHBOARD_VIEW,
      POWER_BI_VIEW,

      // Unbalance permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.UNBALANCE_PAGE, [UNBALANCE_VIEW]),

      FORECAST_VIEW,

      // Map permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.MAP_PAGE, [MAP_VIEW]),

      BUSINESS_PLAN_AND_LOGS_VIEW,
      BUSINESS_PLAN_DOWNLOAD_TEMPLATE,
      BUSINESS_PLAN_UPLOAD,

      // Administration permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.ADMINISTRATION_PAGE, [
        ADMINISTRATION_VIEW,
        ADMINISTRATION_EDIT,
        ADMINISTRATION_CREATE,
        ADMINISTRATION_DELETE,
      ]),

      // Restrictions Journal permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.RESTRICTIONS_JOURNAL_PAGE, [
        RESTRICTIONS_JOURNAL_VIEW,
        RESTRICTIONS_JOURNAL_EDIT,
        RESTRICTIONS_JOURNAL_CREATE,
        RESTRICTIONS_JOURNAL_DELETE,
        RESTRICTIONS_JOURNAL_CALCULATION,
        RESTRICTIONS_JOURNAL_VIEW_CURRENT_PLANT,
      ]),

      OPERATION_JOURNAL_VIEW,
      OPERATION_JOURNAL_EDIT,
      OPERATION_JOURNAL_CREATE,
      OPERATION_JOURNAL_COMMENT_CREATE,
      OPERATION_JOURNAL_VIEW_CURRENT_PLANT,
      OPERATION_JOURNAL_SHIFT_TRANSFER_VIEW,
      OPERATION_JOURNAL_SHIFT_ACCEPTANCE_VIEW,
      OPERATION_JOURNAL_SHIFTS_HISTORY_VIEW,
    ],
  },
  [roles.STATION_SHIFT_SUPERVISOR]: {
    static: [
      DASHBOARD_VIEW,
      POWER_BI_VIEW,

      // Unbalance permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.UNBALANCE_PAGE, [UNBALANCE_VIEW]),

      FORECAST_VIEW,

      // Map permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.MAP_PAGE, [MAP_VIEW]),

      BUSINESS_PLAN_ONLY_VIEW,
      // Restrictions Journal permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.RESTRICTIONS_JOURNAL_PAGE, [
        RESTRICTIONS_JOURNAL_VIEW,
        RESTRICTIONS_JOURNAL_CALCULATION,
      ]),
      OPERATION_JOURNAL_VIEW,
      OPERATION_JOURNAL_EDIT,
      OPERATION_JOURNAL_CREATE,
      OPERATION_JOURNAL_VIEW_CURRENT_PLANT,
      OPERATION_JOURNAL_SHIFT_TRANSFER_VIEW,
      OPERATION_JOURNAL_SHIFT_ACCEPTANCE_VIEW,
      OPERATION_JOURNAL_SHIFTS_HISTORY_VIEW,
    ],
  },
  [roles.USER]: {
    static: [
      DASHBOARD_VIEW,
      POWER_BI_VIEW,

      // Unbalance permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.UNBALANCE_PAGE, [UNBALANCE_VIEW]),

      FORECAST_VIEW,

      // Map permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.MAP_PAGE, [MAP_VIEW]),

      BUSINESS_PLAN_ONLY_VIEW,
      // Restrictions Journal permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.RESTRICTIONS_JOURNAL_PAGE, [RESTRICTIONS_JOURNAL_VIEW]),
      OPERATION_JOURNAL_VIEW,
    ],
  },
  [roles.ANALYST]: {
    static: [
      POWER_BI_VIEW,

      // Unbalance permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.UNBALANCE_PAGE, [UNBALANCE_VIEW]),

      FORECAST_VIEW,

      // Map permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.MAP_PAGE, [MAP_VIEW]),

      BUSINESS_PLAN_AND_LOGS_VIEW,
      BUSINESS_PLAN_DOWNLOAD_TEMPLATE,

      // Restrictions Journal permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.RESTRICTIONS_JOURNAL_PAGE, [RESTRICTIONS_JOURNAL_VIEW]),
      OPERATION_JOURNAL_VIEW,
    ],
  },
  [roles.STATION_ANALYST]: {
    static: [
      DASHBOARD_VIEW,
      POWER_BI_VIEW,

      // Unbalance permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.UNBALANCE_PAGE, [UNBALANCE_VIEW]),

      FORECAST_VIEW,

      // Map permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.MAP_PAGE, [MAP_VIEW]),

      BUSINESS_PLAN_AND_LOGS_VIEW,
      // Restrictions Journal permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.RESTRICTIONS_JOURNAL_PAGE, [
        RESTRICTIONS_JOURNAL_VIEW,
        RESTRICTIONS_JOURNAL_CALCULATION,
      ]),
      OPERATION_JOURNAL_VIEW,
    ],
  },
  [roles.STATION_DIRECTOR]: {
    static: [
      DASHBOARD_VIEW,
      POWER_BI_VIEW,

      // Unbalance permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.UNBALANCE_PAGE, [UNBALANCE_VIEW]),

      FORECAST_VIEW,

      // Map permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.MAP_PAGE, [MAP_VIEW]),

      BUSINESS_PLAN_ONLY_VIEW,
      // Restrictions Journal permissions - controlled by feature flag
      ...getFeaturePermissions(FlagPages.RESTRICTIONS_JOURNAL_PAGE, [RESTRICTIONS_JOURNAL_VIEW]),

      OPERATION_JOURNAL_VIEW,
      OPERATION_JOURNAL_EDIT,
      OPERATION_JOURNAL_CREATE,
      OPERATION_JOURNAL_COMMENT_CREATE,
      OPERATION_JOURNAL_SHIFT_TRANSFER_VIEW,
      OPERATION_JOURNAL_SHIFT_ACCEPTANCE_VIEW,
      OPERATION_JOURNAL_SHIFTS_HISTORY_VIEW,
    ],
  },
}

export {roleTypes}
export default rules
